/** Latest production build of the Lightroom Classic plugin, published by `bkbn-com/lightroom-upload-plugin` `scripts/publish.sh` */
export const lightroomPluginDownloadLink = 'https://storage.googleapis.com/bkbn-lightroom-plugin/production/Backbone.lrplugin.zip'
